
export function isMoreThanNDaysAgo(dateToCheck: Date, daysCount: number) {
    const currentDate = new Date();

    const timeDifference = currentDate.getTime() - dateToCheck.getTime();

    const differenceInDays = timeDifference / (1000 * 3600 * 24);

    // Check if the difference is greater than 3 days
    return differenceInDays > daysCount;
}
